import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Switch,
  Tab,
  TableContainer,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { add, format, isSameDay } from "date-fns";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";

const MARKS_HORAS_ANTECEDENCIA = [
  {
    value: 0,
    label: "0h",
  },
  {
    value: 12,
    label: "12h",
  },
  {
    value: 24,
    label: "24h",
  },
  {
    value: 36,
    label: "36h",
  },
  {
    value: 48,
    label: "48h",
  },
  {
    value: 72,
    label: "72h",
  },
];

const MARKS_MINUTOS_ANTECEDENCIA = [
  {
    value: 0,
    label: "0min",
  },
  {
    value: 15,
    label: "15min",
  },
  {
    value: 30,
    label: "30min",
  },
  {
    value: 45,
    label: "45min",
  },
];

const MARK_DIAS_AGENDAMENTO = [
  {
    value: 0,
    label: "0d",
  },
  {
    value: 1,
    label: "1d",
  },
  {
    value: 5,
    label: "5d",
  },
  {
    value: 10,
    label: "10d",
  },
  {
    value: 15,
    label: "15d",
  },
  {
    value: 20,
    label: "20d",
  },
  {
    value: 30,
    label: "30d",
  },
];

const INTERVALO_HORARIO_AGENDAMENTO = [
  { value: 15, label: "15min" },
  { value: 30, label: "30min" },
  { value: 45, label: "45min" },
  { value: 60, label: "1h" },
];

const MARKS_CAPACIDADE = [
  { value: 0, label: "0" },
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 30, label: "30" },
  { value: 50, label: "50" },
];

const CLEAN_DAYS = [1, 2, 3, 4, 5, 6, 7].map((item) => ({
  dayOfWeek: item,
  times: [],
}));

const DIAS_SEMANA = [
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
  "Domingo",
];

const NOVA_EXCECAO_DEFAULT = {
  data: "",
  modalidade: "ENTREGA",
  tipo: "BLOQUEAR",
  horarios: [],
};

function generateInterval(minutes) {
  const arr = [];
  const originalDate = new Date(0, 0, 0, 0, 0);

  let actualDate = originalDate;

  while (isSameDay(originalDate, actualDate)) {
    arr.push(format(actualDate, "HH:mm"));

    actualDate = add(actualDate, { minutes });
  }

  return arr;
}

export default function ConfiguracaoAgendamento() {
  const { enqueueSnackbar } = useSnackbar();
  const [configuracao, setConfiguracao] = useState({
    situacao: "",
    antecedenciaHoras: "",
    antecedenciaMinutos: 30,
    intervaloHorarioAgendamento: 30,
    capacidadeEntrega: 0,
    capacidadeRetirada: 0,
    respeitarHorarioFuncionamento: false,
  });
  const [intervaloHorarioList, setIntervaloHorarioList] = useState(
    generateInterval(30)
  );
  const [configuracoesDiasEntrega, setConfiguracoesDiasEntrega] = useState([...CLEAN_DAYS]);
  const [configuracoesDiasRetirada, setConfiguracoesDiasRetirada] = useState([...CLEAN_DAYS]);
  const [tabModalidade, setTabModalidade] = useState("ENTREGA");
  const [datasEspecificas, setDatasEspecificas] = useState([]);
  const [openDialogExcecao, setOpenDialogExcecao] = useState(false);
  const [novaExcecao, setNovaExcecao] = useState({ ...NOVA_EXCECAO_DEFAULT });
  const [editIndexExcecao, setEditIndexExcecao] = useState(null);

  useEffect(() => {
    let service = new AuthService();
    service
      .get("/configurarAgendamento/configuracaoAtual")
      .then((configuracaoResp) => {
        const daysEntrega = JSON.parse(configuracaoResp.jsonConfiguracao);
        // Se jsonConfiguracaoRetirada ainda não existir na API, copia a config de entrega como padrão
        const daysRetirada = configuracaoResp.jsonConfiguracaoRetirada
          ? JSON.parse(configuracaoResp.jsonConfiguracaoRetirada)
          : JSON.parse(JSON.stringify(daysEntrega));
        const datasEspecificasResp = configuracaoResp.jsonDatasEspecificas
          ? JSON.parse(configuracaoResp.jsonDatasEspecificas)
          : [];

        setConfiguracao({
          ...configuracaoResp,
          capacidadeEntrega: configuracaoResp.capacidadeEntrega ?? 0,
          capacidadeRetirada: configuracaoResp.capacidadeRetirada ?? 0,
          respeitarHorarioFuncionamento:
            configuracaoResp.respeitarHorarioFuncionamento ?? false,
        });
        setIntervaloHorarioList(
          generateInterval(configuracaoResp.intervaloHorarioAgendamento)
        );
        setConfiguracoesDiasEntrega(daysEntrega);
        setConfiguracoesDiasRetirada(daysRetirada);
        setDatasEspecificas(datasEspecificasResp);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleChange = (event) => {
    setConfiguracao({
      ...configuracao,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeSwitch = (event) => {
    setConfiguracao({
      ...configuracao,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeSlider = (name, value) => {
    if (name === "intervaloHorarioAgendamento") {
      setConfiguracoesDiasEntrega([...CLEAN_DAYS]);
      setConfiguracoesDiasRetirada([...CLEAN_DAYS]);
      setIntervaloHorarioList(generateInterval(value));
    }
    setConfiguracao({ ...configuracao, [name]: value });
  };

  const handleChangeHorarios = (event, indexDiaSemana) => {
    if (tabModalidade === "ENTREGA") {
      const copy = JSON.parse(JSON.stringify(configuracoesDiasEntrega));
      const times = copy[indexDiaSemana].times;
      if (times.includes(event.target.name)) {
        times.splice(times.indexOf(event.target.name), 1);
      } else {
        times.push(event.target.name);
      }
      setConfiguracoesDiasEntrega(copy);
    } else {
      const copy = JSON.parse(JSON.stringify(configuracoesDiasRetirada));
      const times = copy[indexDiaSemana].times;
      if (times.includes(event.target.name)) {
        times.splice(times.indexOf(event.target.name), 1);
      } else {
        times.push(event.target.name);
      }
      setConfiguracoesDiasRetirada(copy);
    }
  };

  const handleSaveConfig = () => {
    const sortTimes = (days) =>
      days.map((config) => ({
        ...config,
        times: [...config.times].sort(),
      }));

    const configuracaoAtualizada = {
      ...configuracao,
      jsonConfiguracao: JSON.stringify(sortTimes(configuracoesDiasEntrega)),
      jsonConfiguracaoRetirada: JSON.stringify(sortTimes(configuracoesDiasRetirada)),
      jsonDatasEspecificas: JSON.stringify(datasEspecificas),
    };

    const service = new AuthService();
    service
      .post("/configurarAgendamento", configuracaoAtualizada)
      .then(() => {
        enqueueSnackbar("Configurações salvas com sucesso", {
          variant: "success",
        });
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao salvar configurações", { variant: "error" });
        console.error(err);
      });
  };

  const verificaDiaSemana = (dia) => " " + DIAS_SEMANA[dia - 1];

  const configuracoesDiasAtual =
    tabModalidade === "ENTREGA" ? configuracoesDiasEntrega : configuracoesDiasRetirada;

  /* ─── Exceções por data ─── */

  const handleAdicionarExcecao = () => {
    if (!novaExcecao.data) {
      enqueueSnackbar("Informe a data da exceção", { variant: "warning" });
      return;
    }
    if (novaExcecao.tipo === "PERSONALIZAR" && novaExcecao.horarios.length === 0) {
      enqueueSnackbar("Selecione ao menos um horário para personalizar", {
        variant: "warning",
      });
      return;
    }

    const excecaoParaSalvar = {
      ...novaExcecao,
      horarios: [...novaExcecao.horarios].sort()
    };

    if (editIndexExcecao !== null && editIndexExcecao !== -1) {
      const novasExcecoes = [...datasEspecificas];
      novasExcecoes[editIndexExcecao] = excecaoParaSalvar;
      setDatasEspecificas(novasExcecoes);
    } else {
      setDatasEspecificas([...datasEspecificas, excecaoParaSalvar]);
    }

    setNovaExcecao({ ...NOVA_EXCECAO_DEFAULT });
    setEditIndexExcecao(null);
    setOpenDialogExcecao(false);
  };

  const handleEditarExcecao = (excecao) => {
    const realIndex = datasEspecificas.findIndex(
      e => e.data === excecao.data && e.modalidade === excecao.modalidade && e.tipo === excecao.tipo
    );
    setEditIndexExcecao(realIndex);
    setNovaExcecao({ ...excecao });
    setOpenDialogExcecao(true);
  };

  const handleRemoverExcecao = (excecao) => {
    setDatasEspecificas(datasEspecificas.filter(
      e => !(e.data === excecao.data && e.modalidade === excecao.modalidade && e.tipo === excecao.tipo)
    ));
  };

  const handleChangeNovaExcecaoHorario = (horario) => {
    const horarios = [...novaExcecao.horarios];
    if (horarios.includes(horario)) {
      horarios.splice(horarios.indexOf(horario), 1);
    } else {
      horarios.push(horario);
    }
    setNovaExcecao({ ...novaExcecao, horarios });
  };

  const labelModalidade = (modalidade) => {
    if (modalidade === "ENTREGA") return "Entrega";
    if (modalidade === "RETIRADA") return "Retirada";
    return "Entrega e Retirada";
  };

  return (
    <>
      <BarraTitulo
        title="Configuração de agendamento"
        subTitle="Trabalha com agendamento? Configure tudo aqui"
      />
      <Paper sx={{ padding: "2rem" }}>

        {/* ─── 1. Modo de operação ─── */}
        <Box>
          <FormControl component="fieldset">
            <Typography>Como sua loja trabalha: </Typography>
            <RadioGroup
              row
              name="situacao"
              value={configuracao.situacao || ""}
              onChange={(e) => handleChange(e)}
            >
              <FormControlLabel
                value="N"
                control={<Radio color="primary" />}
                label="Pedidos sem agendamento"
              />
              <FormControlLabel
                value="NA"
                control={<Radio color="primary" />}
                label="Pedidos com e sem agendamento"
              />
              <FormControlLabel
                value="A"
                control={<Radio color="primary" />}
                label="Somente pedidos agendados"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        <Divider sx={{ marginY: "1.5rem" }} />

        {/* ─── 2. Parâmetros de tempo ─── */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Parâmetros de tempo
          </Typography>
          <Grid container spacing={3} style={{ justifyContent: "space-around" }}>
            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="discrete-slider" gutterBottom>
                Antecedência mínima (em horas)
              </Typography>
              <Slider
                value={configuracao.antecedenciaHoras | ""}
                name="antecedenciaHoras"
                aria-labelledby="discrete-slider"
                step={1}
                min={0}
                max={72}
                marks={MARKS_HORAS_ANTECEDENCIA}
                valueLabelDisplay="auto"
                onChange={(__, value) =>
                  handleChangeSlider("antecedenciaHoras", value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="antecedencia-minutos-slider" gutterBottom>
                Antecedência mínima (em minutos)
              </Typography>
              <Slider
                key={`slider-${configuracao.antecedenciaMinutos}`}
                defaultValue={configuracao.antecedenciaMinutos}
                name="antecedenciaMinutos"
                aria-labelledby="antecedencia-minutos-slider"
                step={15}
                min={0}
                max={45}
                marks={MARKS_MINUTOS_ANTECEDENCIA}
                valueLabelDisplay="auto"
                onChange={(event, value) =>
                  handleChangeSlider("antecedenciaMinutos", value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="discrete-slider" gutterBottom>
                Máximo de dias para agendamento (em dias)
              </Typography>
              <Slider
                value={configuracao.numeroMaximoDiasAgendamento | ""}
                name="numeroMaximoDiasAgendamento"
                aria-labelledby="discrete-slider"
                step={1}
                min={0}
                max={30}
                marks={MARK_DIAS_AGENDAMENTO}
                valueLabelDisplay="auto"
                onChange={(event, value) =>
                  handleChangeSlider("numeroMaximoDiasAgendamento", value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="intervalo-horario-slider" gutterBottom>
                Intervalo Horário de Agendamento
              </Typography>
              <Slider
                key={`slider-${configuracao.intervaloHorarioAgendamento}`}
                defaultValue={configuracao.intervaloHorarioAgendamento}
                name="intervaloHorarioAgendamento"
                aria-labelledby="intervalo-horario-slider"
                step={15}
                min={15}
                max={60}
                marks={INTERVALO_HORARIO_AGENDAMENTO}
                valueLabelDisplay="auto"
                onChange={(event, value) =>
                  handleChangeSlider("intervaloHorarioAgendamento", value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={configuracao.respeitarHorarioFuncionamento || false}
                    onChange={handleChangeSwitch}
                    name="respeitarHorarioFuncionamento"
                    color="primary"
                  />
                }
                label="Respeitar horário de funcionamento no cálculo do prazo de produção"
              />
              <Typography variant="caption" display="block" color="text.secondary">
                Quando ativado, o prazo de produção inicia a contagem a partir do
                próximo horário de abertura, sem considerar horas em que a loja
                está fechada. Exemplo: loja fecha às 18h, pedido às 20h, reabre
                às 8h e prazo é 3h → entrega mínima às 11h.
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ marginY: "1.5rem" }} />

        {/* ─── 3. Capacidade por modalidade ─── */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Capacidade por modalidade
          </Typography>
          <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 2 }}>
            Número máximo de pedidos aceitos por slot de horário. Use 0 para
            ilimitado. Entrega e Retirada têm controle independente — lotação de
            um tipo não bloqueia o outro.
          </Typography>
          <Grid container spacing={3} style={{ justifyContent: "space-around" }}>
            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="capacidade-entrega-slider" gutterBottom>
                Capacidade de Entrega por horário
              </Typography>
              <Slider
                key={`cap-entrega-${configuracao.capacidadeEntrega}`}
                defaultValue={configuracao.capacidadeEntrega ?? 0}
                name="capacidadeEntrega"
                aria-labelledby="capacidade-entrega-slider"
                step={1}
                min={0}
                max={50}
                marks={MARKS_CAPACIDADE}
                valueLabelDisplay="auto"
                onChange={(event, value) =>
                  handleChangeSlider("capacidadeEntrega", value)
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 5 }}>
              <Typography id="capacidade-retirada-slider" gutterBottom>
                Capacidade de Retirada por horário
              </Typography>
              <Slider
                key={`cap-retirada-${configuracao.capacidadeRetirada}`}
                defaultValue={configuracao.capacidadeRetirada ?? 0}
                name="capacidadeRetirada"
                aria-labelledby="capacidade-retirada-slider"
                step={1}
                min={0}
                max={50}
                marks={MARKS_CAPACIDADE}
                valueLabelDisplay="auto"
                onChange={(event, value) =>
                  handleChangeSlider("capacidadeRetirada", value)
                }
              />
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ marginY: "1.5rem" }} />

        {/* ─── 4. Horários disponíveis por modalidade ─── */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Horários disponíveis por modalidade
          </Typography>
          <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 1 }}>
            Configure os horários de forma independente para Entrega e Retirada.
            Bloquear um tipo não afeta o outro.
          </Typography>

          <AppBar position="static" sx={{ mb: 2 }}>
            <Tabs
              value={tabModalidade}
              onChange={(_, newVal) => setTabModalidade(newVal)}
              textColor="inherit"
              sx={{ "& .MuiTab-root": { color: "white" } }}
            >
              <Tab value="ENTREGA" label="Entrega" />
              <Tab value="RETIRADA" label="Retirada" />
            </Tabs>
          </AppBar>

          {configuracoesDiasAtual.map((config, indexDiaSemana) => (
                <Accordion
                  key={indexDiaSemana}
                  TransitionProps={{ unmountOnExit: true }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {verificaDiaSemana(config.dayOfWeek)}
                  </AccordionSummary>
                  <FormControl component="fieldset">
                    <FormGroup>
                      <AccordionDetails>
                        <TableContainer>
                          {intervaloHorarioList.map((horario, index) => (
                            <FormControlLabel
                              key={index}
                              control={
                                <Checkbox
                                  checked={config.times.includes(horario)}
                                  onChange={(e) =>
                                    handleChangeHorarios(e, indexDiaSemana)
                                  }
                                  name={horario}
                                />
                              }
                              label={horario}
                            />
                          ))}
                        </TableContainer>
                      </AccordionDetails>
                    </FormGroup>
                  </FormControl>
                </Accordion>
              ))}
        </Box>

        <Divider sx={{ marginY: "1.5rem" }} />

        {/* ─── 5. Exceções por data ─── */}
        <Box>
          <Box
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            mb={2}
          >
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                Exceções por data
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Bloqueie ou personalize horários de uma data específica (YYYY-MM-DD)
                sem afetar as semanas seguintes. O bloqueio não se replica para
                os mesmos dias da semana automaticamente.
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{ ml: 2, flexShrink: 0 }}
              onClick={() => {
                setNovaExcecao({ ...NOVA_EXCECAO_DEFAULT });
                setEditIndexExcecao(null);
                setOpenDialogExcecao(true);
              }}
            >
              Adicionar exceção
            </Button>
          </Box>

          {datasEspecificas.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nenhuma exceção cadastrada.
            </Typography>
          ) : (
            <List dense>
              {[...datasEspecificas]
                .sort((a, b) => a.data.localeCompare(b.data))
                .map((excecao, index) => (
                  <ListItem
                    key={index}
                    divider
                    secondaryAction={
                      <>
                        <IconButton
                          edge="end"
                          onClick={() => handleEditarExcecao(excecao)}
                          sx={{ mr: 1 }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="end"
                          onClick={() => handleRemoverExcecao(excecao)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    }
                  >
                    <ListItemText
                      primary={`${excecao.data} — ${labelModalidade(excecao.modalidade)}`}
                      secondary={
                        excecao.tipo === "BLOQUEAR"
                          ? "Dia inteiro bloqueado"
                          : `Horários disponíveis: ${excecao.horarios.join(", ")}`
                      }
                    />
                  </ListItem>
                ))}
            </List>
          )}
        </Box>

        <Box
          sx={{ marginTop: "1.5rem" }}
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            onClick={handleSaveConfig}
            sx={{ width: "10rem" }}
            color="secondary"
            variant="contained"
          >
            Salvar
          </Button>
        </Box>
      </Paper>

      {/* ─── Dialog: Adicionar exceção por data ─── */}
      <Dialog
        open={openDialogExcecao}
        onClose={() => {
          setOpenDialogExcecao(false);
          setEditIndexExcecao(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Adicionar Exceção por Data</DialogTitle>
        <DialogContent>
          <Box py={1}>
            <TextField
              label="Data"
              type="date"
              fullWidth
              value={novaExcecao.data}
              onChange={(e) =>
                setNovaExcecao({ ...novaExcecao, data: e.target.value, horarios: [] })
              }
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Box>

          <Box py={1}>
            <Typography variant="subtitle2" gutterBottom>
              Modalidade afetada
            </Typography>
            <RadioGroup
              row
              value={novaExcecao.modalidade}
              onChange={(e) =>
                setNovaExcecao({ ...novaExcecao, modalidade: e.target.value })
              }
            >
              <FormControlLabel value="ENTREGA" control={<Radio />} label="Entrega" />
              <FormControlLabel value="RETIRADA" control={<Radio />} label="Retirada" />
              <FormControlLabel value="AMBOS" control={<Radio />} label="Entrega e Retirada" />
            </RadioGroup>
          </Box>

          <Box py={1}>
            <Typography variant="subtitle2" gutterBottom>
              Tipo de exceção
            </Typography>
            <RadioGroup
              row
              value={novaExcecao.tipo}
              onChange={(e) =>
                setNovaExcecao({ ...novaExcecao, tipo: e.target.value, horarios: [] })
              }
            >
              <FormControlLabel
                value="BLOQUEAR"
                control={<Radio />}
                label="Bloquear dia inteiro"
              />
              <FormControlLabel
                value="PERSONALIZAR"
                control={<Radio />}
                label="Personalizar horários disponíveis"
              />
            </RadioGroup>
          </Box>

          {novaExcecao.tipo === "PERSONALIZAR" && (
            <Box py={1}>
              <Typography variant="subtitle2" gutterBottom>
                Selecione os horários disponíveis nessa data:
              </Typography>
              <FormGroup row>
                {intervaloHorarioList.map((horario) => (
                  <FormControlLabel
                    key={horario}
                    control={
                      <Checkbox
                        checked={novaExcecao.horarios.includes(horario)}
                        onChange={() => handleChangeNovaExcecaoHorario(horario)}
                      />
                    }
                    label={horario}
                  />
                ))}
              </FormGroup>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenDialogExcecao(false);
            setEditIndexExcecao(null);
          }}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={handleAdicionarExcecao}>
            {editIndexExcecao !== null ? "Salvar" : "Adicionar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

